import axios from 'axios'

const state = {
	interventions: [],
	from: {
		date: '',
		weekNumber: '',
		technicianId: ''
	}
};

const getters = {
	interventions: state => state.interventions,
	from: state => state.from
}


const mutations = {
	updateInterventions(state, payload) {
		state.interventions = payload.interventions
		if(payload.interventions.length > 0) {
			state.from = {
				date: payload.day.date,
				weekNumber: payload.day.weekNumber,
				technicianId: payload.technicianId
			}
		} else if(payload.interventions.length === 0) {
			state.from = {
				date: '',
				weekNumber: '',
				technicianId: ''
			}
		}
	},
	clear(state) {
		state.interventions = []
		state.from = {
			date: '',
			weekNumber: '',
			technicianId: ''
		}
	}
}

const actions = {
	toggleCheckInterventions(context, payload) {
		context.commit('updateInterventions', payload)
	},
	clearInterventions(context, payload) {
		context.commit('clear')
	}
}

const calendarTransfer = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

export default calendarTransfer;
